import React from 'react'
import FormField, { FormFieldProps } from './FormField'
import { Typography, useColorMode } from '@airbus/components-react/components'
import DatePicker, { DatePickerProps } from '@airbus/components-react/components/DatePicker'
import { format } from 'date-fns'
import FormControl from './FormControl'
import { FormControlProps } from '@airbus/components-react/components/Form'

type CustomDatePickerProps = DatePickerProps & FormControlProps

export const CustomDatePicker = ({
  label,
  error,
  readOnly = false,
  value,
  onChange,
  labelAdornment,
  required = false,
  style,
  ...rest
}: CustomDatePickerProps) => {
  const theme = useColorMode()

  return (
    <FormControl
      label={label}
      error={error}
      labelAdornment={labelAdornment}
      readOnly={readOnly}
      required={required}
      style={style}
    >
      {readOnly ? (
        <Typography
          style={{
            fontWeight: 'bold',
            lineHeight: theme.size.spacing[40],
            overflowX: 'auto',
          }}
        >
          {(value && !Array.isArray(value) && format(value, 'P')) || '-'}
        </Typography>
      ) : (
        <DatePicker value={value} onChange={onChange} simple {...rest} inputProps={{ tabIndex: 0 }} />
      )}
    </FormControl>
  )
}

export const FormDate = (props: FormFieldProps<CustomDatePickerProps>) => (
  <FormField {...props} Component={CustomDatePicker} />
)

export default FormDate
